/**
 * Shared table standard for project pages. Budget grids set the reference style; every
 * AG Grid and hand-built table on a project page reads its header, frame, row height and
 * money alignment from here.
 */

/** Column header: small uppercase label on a transparent band with a bottom rule. */
export const TABLE_HEADER_CLASS =
  "border-b border-border bg-transparent text-[11px] font-normal uppercase tracking-[0.12em] text-muted-foreground";

/** Rounded, bordered frame around a table. */
export const TABLE_FRAME_CLASS =
  "min-w-0 overflow-hidden rounded-xl border border-border bg-muted/40";

/** Rows that are read or clicked, such as accounts, fringes and summaries. */
export const TABLE_ROW_HEIGHT = 48;

/** Rows with inline inputs, such as budget line items, so the inputs are not clipped. */
export const EDITABLE_TABLE_ROW_HEIGHT = 56;

/** Money and number cells align right so digits line up. */
export const TABLE_MONEY_CELL_STYLE = {
  display: "flex",
  justifyContent: "flex-end",
  alignItems: "center",
  overflow: "hidden",
} as const;
